import { useThree } from '@react-three/fiber'
import { useRuntimeVariables } from 'app-kit'
import { useGeckoAuth } from 'features/auth'
import { RolodexTilesPlugin } from 'features/overview'
import {
  CompassGizmo,
  ReorientationPlugin,
  TilesFadePlugin,
  TilesPluginR3f,
  TilesRendererR3f,
} from 'gecko-3d-tiles-renderer'
import React, { FC, useMemo } from 'react'
import { GeckoSiteModelOrientation } from 'types'

interface MaxarTilesProps {
  siteModelID: string
  siteModelOrientation?: GeckoSiteModelOrientation
}

export const MaxarTiles: FC<MaxarTilesProps> = ({
  siteModelID,
  siteModelOrientation,
}) => {
  const { ROLODEX_URL } = useRuntimeVariables()
  const { authorizedAxios: axios } = useGeckoAuth()
  const { size } = useThree()

  const rolodexPluginOptions = useMemo(() => {
    return {
      entryID: siteModelID,
      rootPath: 'vricon_3dtiles',
      axios,
      rolodexURL: ROLODEX_URL,
    }
  }, [ROLODEX_URL, axios, siteModelID])

  // Dynamic compass positioning like SiteViewMap
  const compassMargin: [number, number] = useMemo(
    () => [25, size.height - 50],
    [size]
  )

  return (
    <group
      position={siteModelOrientation?.position ?? [0, 0, 0]}
      rotation={siteModelOrientation?.rotation ?? [0, 0, 0]}>
      <TilesRendererR3f url={'tileset.json'}>
        <TilesPluginR3f
          plugin={RolodexTilesPlugin}
          args={rolodexPluginOptions}
        />
        <TilesPluginR3f plugin={TilesFadePlugin} fadeDuration={500} />
        <TilesPluginR3f plugin={ReorientationPlugin} />
        <CompassGizmo margin={compassMargin} />
      </TilesRendererR3f>
    </group>
  )
}
